import { connect } from 'react-redux';
import reduxForm from 'redux-form/lib/reduxForm';
import {
  showCreateAccount,
  showRequestResetPassword,
  submitLogInForm,
  isValidEmail,
} from '../../user';
import { Login } from '../Login';

const mapDispatchToProps = (dispatch, ownProps) => {
  const {
    loginCallback,
    shouldRedirectToDashboard,
    csrfToken,
    handleGetCsrfToken,
  } = ownProps;

  return {
    onSubmit: async data => {
      /**
       * we should have a csrf token on mount, but if that failed for some reason,
       * try fetching it again when the user submits, but before we attempt
       * the login request
       */
      let _csrf = csrfToken;
      if (!_csrf) {
        _csrf = await handleGetCsrfToken();
      }
      return dispatch(
        submitLogInForm(
          { ...data, _csrf },
          loginCallback,
          shouldRedirectToDashboard
        )
      );
    },
    clickCreateAccount: () => dispatch(showCreateAccount('Create Account')),
    clickRequestResetPassword: () =>
      dispatch(showRequestResetPassword('Forgot Password')),
  };
};

// eslint-disable-next-line no-empty-pattern
const mapStateToProps = ({}, { feedUrl, signupUrl }) => ({
  feedUrl,
  signupUrl,
});

function validateLoginForm(formValues) {
  const { email, password } = formValues;
  const errors = {};
  if (!email) errors.email = 'Email is required';
  if (email && !isValidEmail(email)) errors.email = 'Email is invalid';
  if (!password) errors.password = 'Password is required';
  return errors;
}

const LoginContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: 'login',
    validate: validateLoginForm,
  })(Login)
);

export { LoginContainer };
